import NoItemsDisplay from 'components/molecules/NoItemsDisplay/NoItemsDisplay';
import React from 'react';
import styles from './SoftSkillTabSection.module.scss';

type SoftSkillTabSectionProps = {
  title: string;
  description: string | React.ReactNode;
  children: React.ReactNode;
  hasNoItems?: boolean;
  noItemLabel?: string;
};

const SoftSkillTabSection = ({
  title,
  description,
  children,
  hasNoItems,
  noItemLabel,
}: SoftSkillTabSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
      {hasNoItems ? <NoItemsDisplay label={noItemLabel} /> : children}
    </div>
  );
};

export default SoftSkillTabSection;
